export default "https://cdn-static.gokick.com/assets/f9e57853bbf9ca449046a7aa5fdd940e337957cb/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";